import { MutationCache, QueryClient } from '@tanstack/react-query';
import { ApiError } from './api.js';
import { showToast } from './toast.js';

// Default mutation error handler — every useMutation that doesn't pass an
// onError gets a toast with the unpacked error. Routes can still pass
// onError to do something more specific; this is the safety net so a
// silent failure can never sneak through.
function defaultErrorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    const body = err.body as { message?: string; error?: string } | null;
    if (body?.message) return body.message;
    if (body?.error) return body.error;
    return `${String(err.status)} ${err.message}`;
  }
  if (err instanceof Error) return err.message;
  return 'Unexpected error';
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
  mutationCache: new MutationCache({
    onError: (err, _vars, _ctx, mutation) => {
      // If the call site already handles the error itself, don't double-toast.
      if (mutation.options.onError) return;
      showToast('error', defaultErrorMessage(err));
    },
  }),
});
